import { cn } from 'lib/utils';
import { useTranslation } from 'react-i18next';

export const SuggestedLabel = ({ status, className }: any) => {
    const { t } = useTranslation('translation');
    if (status !== 'SUGGESTED') return null;
    return (
        <div className={cn('bg-zinc-700 text-white px-1 font-medium text-xs h-[20px] leading-5', className)}>
            {t('filters.suggested').toLowerCase()}
        </div>
    );
};
